import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';

class StartschermCoreService {
}
StartschermCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StartschermCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreService, decorators: [{
            type: Injectable
        }] });

class StartschermCoreModule {
    static forRoot() {
        return {
            ngModule: StartschermCoreModule,
            providers: [
                // following services need to be singleton over all modules
                StartschermCoreService
            ]
        };
    }
}
StartschermCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StartschermCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreModule });
StartschermCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StartschermCoreModule, decorators: [{
            type: NgModule
        }] });

/*
 * Public API Surface of @lvflanders/startscherm-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StartschermCoreModule, StartschermCoreService };
//# sourceMappingURL=lvflanders-startscherm-ng.mjs.map
